import { render } from "./write-in-controls.vue?vue&type=template&id=0dc52a74"
import script from "./write-in-controls.vue?vue&type=script&lang=js"
export * from "./write-in-controls.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__